import { useState } from "react"
import VerificationLayout from "../../components/verification/VerificationLayout.jsx"
import StatusBox from "../../components/verification/StatusBox.jsx"
import PatientDetails from "../../components/verification/PatientDetails.jsx"
import { useLocation } from "react-router-dom"
import Button from "../../components/ui/Button.jsx"
import EmailController from "@/network/controllers/email.controller.js"


export default function ConsentOutdated() {
  const [icfSent, setIcfSent] = useState(false);
  const location = useLocation();
  const { patientData, lastAction } = location.state || {};

  const handleResendICF = async () => {
    if (
      !patientData ||
      !patientData.email ||
      !patientData.firstname ||
      !patientData.lastname ||
      !patientData.participantId
    ) {
      console.warn(" Missing patient data for resending ICF.");
      return;
    }

    const res = await EmailController.resendICF({
      email: patientData.email,
      firstname: patientData.firstname,
      lastname: patientData.lastname,
      participantId: patientData.participantId,
    });

    if (res?.success) {
      setIcfSent(true);
    } else {
      console.error(" Failed to resend ICF email:", res);
    }
  };

  return (
    <VerificationLayout title="Verification - Outdated">
      <StatusBox
        type="warning"
        title="Consent outdated"
        message="The patient's informed consent is not valid."
        bordered={icfSent}
      />

      <PatientDetails patient={patientData} lastAction={lastAction} />

      <div className="mt-6 space-y-4">
        <p>Do not proceed with any medical procedure until the patient has signed a new informed consent.</p>
        <p>Please redirect the patient to the reconsent process.</p>
        <p>Once the reconsent is completed, you will be able to proceed with milestone logging.</p>
      </div>

      <p className="mt-8 text-center">
        You may close this window and scan the QR code again once the new consent has been registered.
      </p>

      {!icfSent ? (
        <div className="flex justify-center mt-8">
          <Button className="text-white rounded-xl" variant="QrCode" onClick={handleResendICF}>
            Resend ICF
          </Button>
        </div>
      ) : (
        <div className="text-center mt-8 text-2xl">ICF sent to the patient</div>
      )}
    </VerificationLayout>
  );
}